/* eslint-disable react/prop-types */
import { Box, CircularProgress, Grid, IconButton } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'
import React from 'react'
import styled from 'styled-components'
import Layout from '../../components/layout_admin'
import PageTitle from '../../components/page_title'
import { toString, getStringTime } from '../../../helpers/date'
import { addMinutes } from 'date-fns'
import { cfdiCollection, conceptbill, methodPayAppointmentAdmin } from '../../../constants'

const PaidStatus = styled.div`
  cursor: pointer;
  font-size: 1.3em;
  background-color: ${props => props.$color};
  display: inline-flex;
  align-items: center;
  padding: .2em 1.2em;
  border-radius: 5px;
  color: #fff;
  svg {
    margin-right: 1em;
  }
`

const Limiter = styled.div`
  max-width: 1000px;
  margin: 20px auto;
  @media screen and (max-width:1550px) {
    font-size: .9em;
    max-width: 900px;
  }
  @media screen and (max-width:1300px) {
    max-width: 800px;
  }
  @media screen and (max-width:1279px) {
    max-width: 500px;
  }
`

const Row = styled.div`
  font-size: 1.3em;
  color: var(--firts);
  span {
    color: var(--second);
    margin-right: 1em;
    font-weight: bold;
  }
`

const SubTitle = styled.div`
  font-size: 1.5em;
  color: var(--first);
  margin: 10px 0px;
  font-weight: bold;
`

const View = props => {
  const isOldDate = addMinutes(props.operationDate, 2880).getTime() < Date.now()

  return (
    <Layout title='Detalles de cita'>
      <PageTitle>Detalles de cita</PageTitle>
      {props.loading && (
        <Grid container justify='center' alignItems='center' style={{ minHeight: '85vh' }}>
          <CircularProgress color='secondary' />
        </Grid>
      )}

      {!props.loading && (
        <Limiter>
          <Box mt={4} mb={4} display='flex' alignItems='center'>
            <PaidStatus $color={isOldDate && !props.isPaid ? 'red' : props.isPaid ? 'green' : 'orange'} onClick={props.onOpenChangePaidStatus}>
              <Edit />{isOldDate && !props.isPaid ? 'Vencido' : props.isPaid ? 'Pagado' : 'pago pendiente'}
            </PaidStatus>
            <IconButton onClick={props.onDelete}>
              <Delete style={{ color: 'red' }} />
            </IconButton>
          </Box>
          <Box mt={5}>
            <SubTitle>Cita</SubTitle>
            <Row> <span>Fecha:</span> {toString(props.date)}</Row>
            <Row> <span>Hora:</span> {getStringTime(props.date)}</Row>
            <Row> <span>Fecha de registro:</span> {toString(props.operationDate)}</Row>
            <Row> <span>Id:</span> {props._id}</Row>
          </Box>
          <Box mt={5}>
            <SubTitle>Datos pesonales</SubTitle>
            <Grid container spacing={0}>
              <Grid item xs={12} lg={6}><Row> <span>Nombre</span> {props.name} {props.plastname} {props.mlastname}</Row></Grid>
              <Grid item xs={12} lg={6}><Row> <span>Fecha de nacimiento:</span> {props.birtdate}</Row></Grid>
              <Grid item xs={12} lg={6}><Row> <span>Correo:</span> {props.email}</Row></Grid>
              <Grid item xs={12} lg={6}><Row> <span>Telefono:</span> {props.phone}</Row></Grid>
              <Grid item xs={12} lg={6}> <Row> <span>Método de pago:</span> {methodPayAppointmentAdmin[props.methodPay]}</Row></Grid>
            </Grid>
          </Box>
          {props.willBill === 'yes' && (
            <Box mt={5}>
              <SubTitle>Datos de facturacion</SubTitle>
              <Grid container spacing={0}>
                {props.billRfc && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>RFC</span> {props.billRfc} </Row>
                  </Grid>
                )}
                {props.billSocial && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Razon social</span> {props.billSocial}</Row>
                  </Grid>
                )}
                {props.conceptbill && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Concepto de facturación</span> {conceptbill[props.conceptbill]}</Row>
                  </Grid>
                )}
                {props.billStreet && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Calle:</span> {props.billStreet}</Row>
                  </Grid>
                )}
                {props.billSuburb && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Colonia:</span> {props.billSuburb}</Row>
                  </Grid>
                )}
                {props.billExtNum && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Numero Exterior:</span> {props.billExtNum}  <span>Numero Interior:</span> {props.billIntNum} </Row>
                  </Grid>
                )}
                {props.billState && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Estado:</span>{props.billState}</Row>
                  </Grid>
                )}

                {props.billCity && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Minicipio:</span> {props.billCity}</Row>
                  </Grid>
                )}
                {props.billPostalCode && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Codigo postal:</span> {props.billPostalCode}</Row>
                  </Grid>
                )}

                {props.billEmail && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>Correo:</span> {props.billEmail}</Row>
                  </Grid>
                )}
                {props.cfdi && (
                  <Grid item xs={12} lg={6}>
                    <Row> <span>CFDI:</span> {cfdiCollection[props.cfdi]}</Row>
                  </Grid>
                )}

              </Grid>

            </Box>
          )}
          <Box mt={5}>
            <SubTitle>Como se entero de nosotros</SubTitle>
            <Row as='ul'>
              <Grid container spacing={0}>
                {props.realeaseByFacebook && (<Grid item xs={12} lg={6}><li>Facebook</li></Grid>)}
                {props.realeaseByRefer && (<Grid item xs={12} lg={6}><li>Recomendacion</li></Grid>)}
                {props.realeaseByWeb && (<Grid item xs={12} lg={6}><li>Pagina web</li></Grid>)}
                {props.realeaseCompany && (<Grid item xs={12} lg={6}><li>Empresa</li></Grid>)}
                {props.releaseByOtherText && (<Grid item xs={12} lg={6}><div>Otro: {props.releaseByOtherText}</div></Grid>)}
              </Grid>
            </Row>
          </Box>
          <Box mt={5}>
            <SubTitle>Motivo por el qué se realiza el estudio</SubTitle>
            <Row as='ul'>
              <Grid container spacing={0}>
                {props.studyReasonCirugia && (<Grid item xs={12} lg={6}><li>Cirugía</li></Grid>)}
                {props.studyReasonContactWidtPeople && (<Grid item xs={12} lg={6}><li>Contacto con persona COVID-19 detectado (positivo)</li></Grid>)}
                {props.studyReasonProfecional && (<Grid item xs={12} lg={6}><li>Profesional de la salud</li></Grid>)}
                {props.studyReasonSintomas && (<Grid item xs={12} lg={6}><li>Presenta síntomas</li></Grid>)}
                {props.studyReasonViaje && (<Grid item xs={12} lg={6}><li>Viaje</li></Grid>)}
                {props.studyReasonOtherText && (<Grid item xs={12} lg={6}><div>Otro: {props.studyReasonOtherText}</div></Grid>)}
              </Grid>
            </Row>
          </Box>

        </Limiter>
      )}
    </Layout>
  )
}

export default View
